import { Box, LoadingOverlay, RingProgress, Text } from "@mantine/core";
import { Outlet } from "react-router-dom";

import { useDesktopDatabaseSync } from "../hooks";

const ProtectedRouteContent = () => {
  return <Outlet />;
};

export default ProtectedRouteContent;
